// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5333ad58","506":"db82f735","704":"72aa13ef"}[chunkId] + ".chunk.js";
};